import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';

const PlanExpiredBar = () => {
  
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 1.5,
        backgroundColor: '#FFCC00',
        color: '#ffffff',
        width: '100%',
        boxSizing: 'border-box',

        position: 'sticky',
        top: 0,
  
        zIndex: 1100,
      }}
    >
      <InfoIcon sx={{ mr: 1.5 }} />
      <Typography variant="body1" component="p" sx={{ fontWeight: 'medium' }}>
        Your plan has expired, contact your assigned Customer Success Manager (CSM) for more information.
      </Typography>
    </Box>
  );
};

export default PlanExpiredBar;